import React from 'react'
import ReactDOM from 'react-dom'
// import * as Sentry from '@sentry/browser'
import portalKit from '@portal/kit'
import i18n from 'locales'
import App from 'components/app'
import initMocks from 'mocks'
import { registerLocale, setDefaultLocale } from "react-datepicker";
import i18next from "i18next";

import {enGB, fr, es, de } from 'date-fns/esm/locale'

const locales = { en: enGB, es, fr, de }

Object.keys(locales).forEach((key) => registerLocale(key, locales[key]))

if (process.env.NODE_ENV !== 'development') {
  // Sentry.init({
  //   dsn: "https://9867d8cbfd114614bd91a5a7faa884fe@sentry.io/1852881",
  //   environment: process.env.REACT_APP_SENTRY_ENV,
  // })
}

portalKit.captureConsole()

portalKit.configure({
  ENVIRONMENT:          process.env.NODE_ENV,
  BASE_API_URL:         process.env.REACT_APP_API_URL,
  MOCKS_ENABLED:        process.env.REACT_APP_ENABLE_MOCKS === 'true',
  JWT_COOKIE_NAME:      process.env.REACT_APP_JWT_COOKIE_NAME,
  REMEMBER_COOKIE_NAME: process.env.REACT_APP_REMEMBER_COOKIE_NAME,
  PHONE_CONFIRMATION_COOKIE_NAME: process.env.REACT_APP_PHONE_CONFIRMATION_COOKIE_NAME,
  COOKIE_DOMAIN:        process.env.REACT_APP_COOKIE_DOMAIN,
  ASSETS_URL:           process.env.REACT_APP_ASSETS_URL,
  LOCALE:               i18n.language,
  PORTAL_CONFIGURATION_MODIFIERS: [config => {
    config.theme = 'default' // disables dark theme for selfcare
  }],
  initMocks,
})

setDefaultLocale(i18next.language)

i18next.on('languageChanged', function (lng) {
  if (locales[lng]) {
    setDefaultLocale(lng)
  } else {
    setDefaultLocale('en')
  }
})

ReactDOM.render(<App />, document.getElementById('root'))
